import * as React from 'react';
import { tag } from '../../../../model/tag';
import Tag from '../Tag/Tag';
import { Typography, Grid } from '@material-ui/core';

export interface ITagsProps {
  tags?: tag[];
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: ITagsProps) => {
  if (props.tags && props.tags.length > 0)
    return (
      <>      <Grid item xs={12} >
        <Typography style={{ fontWeight: "bold", marginTop: "10px" }}>Tag</Typography></Grid>
        {props.tags.map(t => <Tag tag={t} key={t.code} />)}
      </>
    );
  else return (
    <>
    </>);
}